import styled from 'styled-components';

import { Box } from '@/components/Box';
import { DEFAULT_MOBILE_HEADER_HEIGHT } from '@/theme/dimensions';

export const topMenuHeight = DEFAULT_MOBILE_HEADER_HEIGHT - 2;
export const Wrapper = styled.aside<{ isOpen: boolean; top: number }>`
  position: fixed;
  inset: 0;
  top: ${({ top }) => top ?? topMenuHeight}px;
  width: 100%;
  overflow: hidden;
  height: calc(100% - ${({ top }) => top ?? topMenuHeight}px);
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.white};
  backdrop-filter: ${({ theme }) => theme.components.mobileMenu.backdropFilter};
  z-index: ${({ theme }) => theme.zIndex.mobileMenu};
  transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 0.5s ease;
`;

export const BottomMenu = styled(Box)`
  margin-top: auto;
  border-top: 1px solid #ebebeb;
  padding: ${({ theme }) => theme.space.s120};
`;

export const ListItem = styled.li`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.white};

  svg {
    transition: color 0.2s;

    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const BottomListItem = styled.li`
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.almostBlack};
  transition: color 0.2s;

  svg {
    transition: color 0.2s;
  }

  &:hover {
    svg {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;
